module.exports = __webpack_public_path__ + "static/img/981d722.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/livepoint/dl.png
// module id = 655
// module chunks = 2